import ClickOutside from '@/directives/clickOutside'

export default {
  data () {
    return {
      show: false
    }
  },
  directives: {
    ClickOutside
  },
  methods: {
    onClickOutside () {
      this.show = false
    },
    on () {
      this.show = !this.show
    }
  }
}
